import { render, staticRenderFns } from "./g-input-number-suffix.vue?vue&type=template&id=316c611f&scoped=true&"
import script from "./g-input-number-suffix.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-input-number-suffix.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./g-input-number-suffix.vue?vue&type=style&index=0&id=316c611f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c611f",
  null
  
)

export default component.exports